export const devicesSelector = state => state.deviceManagement.devices

export const requestingDevicesSelector = state =>
  state.deviceManagement.requestingDevices

export const deviceSearchQuerySelector = state =>
  state.deviceManagement.searchQuery

export const registeringDeviceSelector = state =>
  state.deviceManagement.registeringDevice

export const registerDeviceErrorSelector = state =>
  state.deviceManagement.registerDeviceError

export const shipOptionsSelector = state => state.deviceManagement.shipOptions

export const requestingShipOptionsSelector = state =>
  state.deviceManagement.requestingShipOptions
